import { render, staticRenderFns } from "./FixedPhraseEditTreeSelector.vue?vue&type=template&id=65764766&scoped=true&"
import script from "./FixedPhraseEditTreeSelector.vue?vue&type=script&lang=ts&"
export * from "./FixedPhraseEditTreeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FixedPhraseEditTreeSelector.vue?vue&type=style&index=0&id=65764766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65764766",
  null
  
)

export default component.exports